// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employee-benefits-in-kind",
  Create: "/pyr/employee-benefits-in-kind",
  Update: "/pyr/employee-benefits-in-kind",
  Import: "/pyr/employee-benefits-in-kind/import",
};
